import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8 .5c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8m0 14.4a6.407 6.407 0 0 1-6.4-6.4c0-3.529 2.871-6.4 6.4-6.4s6.4 2.871 6.4 6.4-2.871 6.4-6.4 6.4" }, null, -1),
    _createElementVNode("path", { d: "M6.4 9.77 4.56 7.934 3.43 9.066 6.4 12.03l5.366-5.364-1.132-1.132z" }, null, -1),
    _createElementVNode("path", { d: "M8 .5c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8m0 14.4a6.407 6.407 0 0 1-6.4-6.4c0-3.529 2.871-6.4 6.4-6.4s6.4 2.871 6.4 6.4-2.871 6.4-6.4 6.4" }, null, -1),
    _createElementVNode("path", { d: "M6.4 9.77 4.56 7.934 3.43 9.066 6.4 12.03l5.366-5.364-1.132-1.132z" }, null, -1)
  ]))]))
}
export default { render: render }